<fc-search-input
  [label]="'ADDRESS.LABEL' | translate"
  [control]="control"
  [options]="options"
  [search]="search"
  [displayWith]="displayWith"
  [showSearchIcon]="showSearchIcon"
  [requiredMark]="requiredMark"
  [preloadOptions]="preloadOptions"
  [searchOnFocus]="searchOnFocus"
  [validation]="validation"
  [translateErrorPrefix]="translateErrorPrefix"
></fc-search-input>
